import config from 'app/config';

function getImage(src, options = {}) {
  const host = config.get('IMAGE_API_HOST');
  const params = [];

  const imgSource = src && src.original ? src.original : src;

  if (!isNaN(options.w)) {
    params.push(`w=${options.w}`);

    if (!isNaN(options.h)) {
      params.push(`h=${options.h}`);
    } else {
      params.push(`h=${options.w}`);
    }
  }

  if (!isNaN(options.blur)) {
    params.push(`blur=${options.blur}`);
  }

  if (!isNaN(options.quality)) {
    params.push(`quality=${options.quality}`);
  }

  const queryString = params.length === 0 ? '' : `&${params.join('&')}`;

  return `${host}/image?source=${imgSource}${queryString}`;
}

export { getImage };
